class ErrorResult {
    errorCode: string = ""
    errorMessage: string = ""
    hasError: boolean = false
}

export {
    ErrorResult
}
